import authAxios from "../utils/authAxios";

const versionClient = {
    getVersion: async () => {
        return await authAxios(`/api/version`, {
            method: 'GET',
        });
    },
};

export default versionClient;
